import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";
import { ROUTES } from "@/routes/paths";

export const AdoptionAndEngagement = () => {
  const { t } = useTranslation();
  return (
    <div>
      <div className="w-full border-b p-6 pb-0">
        <h1 className="mb-4 text-2xl font-bold text-foreground">
          {t("adoption.title")}
        </h1>
        <div className="flex gap-10">
          <TabLink to={""} text={t("adoption.tabs.student")} />
          <TabLink
            to={ROUTES.ANALYTICS.ENGAGEMENT_DATA}
            text={t("adoption.tabs.engagementData")}
          />
        </div>
      </div>
      <div className="p-6">
        <Outlet />
      </div>
    </div>
  );
};

const TabLink = ({ to, text }: { to: string; text: string }) => (
  <NavLink
    to={to}
    end
    className={({ isActive }) =>
      cn(
        "pb-4 text-sm",
        isActive ? "border-b-3 border-primary font-semibold" : "text-slate-400",
      )
    }
  >
    {text}
  </NavLink>
);
